
import {Vue, Component} from 'vue-property-decorator';
import {getZonedBookingDate} from '@/utils';
import {DateTime} from 'luxon';
import {nil} from '@/common';
@Component({
    components: {
    },
})
export default class BookingDateMixin extends Vue {
    public booking: any;
    get zonedBookingDate(){
        if(nil(this.booking)) return DateTime.local();
        return getZonedBookingDate(this.booking);
    }
    get localBookingDate(){
        if(nil(this.booking)) return DateTime.local();
        return DateTime.fromISO(this.booking.date).toLocal();
    }

}
